import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Link from "core-web/components/Link";
import styled from "theme/libs/styled";
import ModulesLoading from "theme/libs/wordpress/content/ModulesLoading";
import ThemeButton from "theme/components/buttons/ThemeButton";
import TextStyles from "theme/components/text/TextStyles";
import Promotion from "./Promotion";

const Wrapper = styled("div")``;

const TitleWrapper = styled("div")`
    display: flex;
    justify-content: space-between;

    ${({ theme }) => theme.below.tabletSm} {
        flex-direction: column;
        gap: 16px;
    }
`;

const PromotionWrapper = styled("div")`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
`;

const Promotions = ({ maxCount, showMoreButton, moreButtonLink }) => {
    const { t } = useTranslation();
    const { promotions, promotionsLoading } = useSelector(({ user }) => user) ?? {};

    if (!promotions?.length) {
        return null;
    }

    const countedPromotions = maxCount === -1 ? promotions : promotions.slice(0, maxCount);

    return (
        <Wrapper>
            <TitleWrapper>
                <TextStyles textStyles="Buenos Aires/32-120 SemiBold">{t("member.promotions.heading")}</TextStyles>
                {showMoreButton && !!moreButtonLink.length && (
                    <ThemeButton buttonTheme="black_outline" as={Link} to={moreButtonLink}>
                        {t("member.promotions.view_all")}
                    </ThemeButton>
                )}
            </TitleWrapper>
            <PromotionWrapper>
                {promotionsLoading && <ModulesLoading />}
                {countedPromotions.map((promotion) => (
                    <Promotion data={promotion} />
                ))}
            </PromotionWrapper>
        </Wrapper>
    );
};

Promotions.propTypes = {
    maxCount: PropTypes.number,
    showMoreButton: PropTypes.bool,
    moreButtonLink: PropTypes.string,
};

Promotions.defaultProps = {
    maxCount: -1,
    showMoreButton: false,
    moreButtonLink: "",
};

export default Promotions;
